// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { fermentationGroupId } from './FermentationGroup';
import { fermentationProcedureAlertId } from './FermentationProcedureAlert';
import { fermentationAlertKindEnum } from './FermentationAlertKindEnum';
import { fermentationAttributeDefinitionId } from './FermentationAttributeDefinition';
import { fermentationAlertLimitModeEnum } from './FermentationAlertLimitModeEnum';
import { operatorId } from './Operator';
import { z } from 'zod';
export const fermentationGroupAlertId = (z.number());
export const fermentationGroupAlert = z.object({
    id: fermentationGroupAlertId,
    fermentation_group_id: fermentationGroupId,
    procedure_alert_id: fermentationProcedureAlertId.nullable(),
    kind: fermentationAlertKindEnum,
    enabled: z.boolean(),
    duration_s: z.number(),
    attribute_id: fermentationAttributeDefinitionId.nullable(),
    limit_mode: fermentationAlertLimitModeEnum.nullable(),
    min_value: z.string().nullable(),
    max_value: z.string().nullable(),
    deviation_below: z.string().nullable(),
    deviation_above: z.string().nullable(),
    setpoint_attribute_id: fermentationAttributeDefinitionId.nullable(),
    display_order: z.number(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
});
export const fermentationGroupAlertInitializer = z.object({
    id: fermentationGroupAlertId.optional(),
    fermentation_group_id: fermentationGroupId,
    procedure_alert_id: fermentationProcedureAlertId.optional().nullable(),
    kind: fermentationAlertKindEnum,
    enabled: z.boolean().optional(),
    duration_s: z.number().optional(),
    attribute_id: fermentationAttributeDefinitionId.optional().nullable(),
    limit_mode: fermentationAlertLimitModeEnum.optional().nullable(),
    min_value: z.string().optional().nullable(),
    max_value: z.string().optional().nullable(),
    deviation_below: z.string().optional().nullable(),
    deviation_above: z.string().optional().nullable(),
    setpoint_attribute_id: fermentationAttributeDefinitionId.optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
export const fermentationGroupAlertMutator = z.object({
    id: fermentationGroupAlertId.optional(),
    fermentation_group_id: fermentationGroupId.optional(),
    procedure_alert_id: fermentationProcedureAlertId.optional().nullable(),
    kind: fermentationAlertKindEnum.optional(),
    enabled: z.boolean().optional(),
    duration_s: z.number().optional(),
    attribute_id: fermentationAttributeDefinitionId.optional().nullable(),
    limit_mode: fermentationAlertLimitModeEnum.optional().nullable(),
    min_value: z.string().optional().nullable(),
    max_value: z.string().optional().nullable(),
    deviation_below: z.string().optional().nullable(),
    deviation_above: z.string().optional().nullable(),
    setpoint_attribute_id: fermentationAttributeDefinitionId.optional().nullable(),
    display_order: z.number().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
});
//# sourceMappingURL=FermentationGroupAlert.js.map